export type { NewsPageProps } from "./news-page";
export { NewsPage } from "./news-page";
